import { Box, Typography } from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';

export function EmptyState() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        textAlign: 'center',
        p: 3,
      }}
    >
      <DescriptionIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        Chưa có báo cáo lỗi nào
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Nhấn 'Tạo báo cáo mới' để bắt đầu
      </Typography>
    </Box>
  );
}
